import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
export function FinalCTA() {
  return <section className="py-20 bg-deep-black text-white relative overflow-hidden" data-id="element-63">
      <div className="absolute inset-0 opacity-20" data-id="element-64">
        <img src="https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?auto=format&fit=crop&q=80&w=2000" alt="Background" className="w-full h-full object-cover" data-id="element-65" />
        <div className="absolute inset-0 bg-deep-black/80" data-id="element-66"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-68">
          <h2 className="text-3xl sm:text-5xl font-playfair mb-8 leading-tight" data-id="element-69">
            Ya es hora de{' '}
            <strong className="font-bold underline decoration-gold decoration-2 underline-offset-4" data-id="element-70">
              dejar de perseguir
            </strong>{' '}
            hombres sin compromiso y aceptar migajas.
          </h2>
          <p className="text-xl sm:text-2xl font-cormorant italic text-gold mb-12" data-id="element-71">
            Es hora de convertirte en la{' '}
            <span className="not-italic font-playfair font-bold text-white bg-bordeaux-vivid/40 px-2 rounded-sm" data-id="element-72">
              Diosa Letal
            </span>{' '}
            en la que ellos no pueden dejar de pensar.
          </p>

          <CTAButton scrollTo="oferta-final" className="w-full sm:w-auto text-sm sm:text-base py-5 px-10" data-id="element-73">
            Descargar Ahora
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}